import { useTranslation } from 'react-i18next'

export const BRAND_LOGO_SRC = '/logo.svg.png'

type BrandMarkProps = {
  size?: number
  className?: string
  /** Pass empty string when a nearby wordmark already names the app. */
  alt?: string
}

export function BrandMark({ size = 32, className = '', alt }: BrandMarkProps) {
  const { t } = useTranslation('common')
  return (
    <img
      src={BRAND_LOGO_SRC}
      alt={alt === undefined ? t('appName') : alt}
      width={size}
      height={size}
      className={['brand-mark', className].filter(Boolean).join(' ')}
      draggable={false}
    />
  )
}
